import React from "react";
import BottomServiceBanner from "../../../components/ServiceBanner/BottomServiceBanner";
import TopServiceBanner from "../../../components/ServiceBanner/TopServiceBanner";
import { JumbotronContainer } from "../../../containers/Jumbotron/Jumbotron";
import styled from "styled-components/macro";
import banner from "../../../assets/images/banner/pharmacy.jpg"
import BottomBanner from "../../../components/ServiceBanner/BottomBanner";

// import Aos from 'aos';
// import 'aos/dist/aos.css';
// import { useEffect } from "react";

const Pharmacy = () => {

  // useEffect(() => {
  //   Aos.init({duration: 2000});
  // }, []);

  return (
    <div className="pharmacy-container" >
      <TopServiceBanner title="Pharmacy Services"  banner={banner}/>
      <br />
      <PharmacySubTitle>
        We understand that there is nothing like one size fits all solution.
        Every person is unique and thus, requires special attention depending on
        his or her situation. Therefore, our staff open heartedly welcomes every
        individual who visits our pharmacy, and is ready to help them with their
        specific needs with a wide range of products and services.
      </PharmacySubTitle>
      <PharmacySubTitle>
        Our primary motive is to render the utmost professional and personal
        quality of service that our customers expect from us as quickly and
        efficiently as possible.
      </PharmacySubTitle>
      <PharmacyTitle>OUR EXTENSIVE ARRAY OF SERVICES INCLUDES</PharmacyTitle>
      <PharmacyJumbotronContainer>
        <JumbotronContainer />
      </PharmacyJumbotronContainer>
      <BottomServiceBanner />
      <BottomBanner />

    </div>
  );
};

export default Pharmacy;

const PharmacyTitle = styled.h1`
  font-size: 40px;
  line-height: 1.1;
  color: var(--color-blue);
  text-align: center;
  margin-top: 3rem;
  letter-spacing: 1.5px;

  &:hover {
    color: var(--color-red);
  }

  @media (max-width: 1000px) {
    font-size: 30px;
  }
  @media (max-width: 600px) {
    font-size: 28px;
  }
  @media (max-width: 460px) {
    font-size: 22px;
  }
`;

const PharmacySubTitle = styled.h2`
  font-size: 22px;
  font-weight: normal;
  line-height: normal;
  opacity: 0.7;
  text-align: center;
  padding: 0rem 3rem 1rem 3rem;
  margin-top: 2rem;
  opacity: 0.6;

  @media (max-width: 600px) {
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }

  @media (max-width: 460px) {
    font-size: 15px;
  }
`;

const PharmacyJumbotronContainer = styled.div`
  margin-top: 5rem;
  `;
  